import { TransactionPaymentRail, TransactionPaymentRailsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchTransactionPaymentRails() {
  const [fetching, setFetching] = useState(false);
  const [paymentRails, setPaymentRails] = useState<TransactionPaymentRail[]>([]);

  async function fetchTransactionPaymentRails(params: TransactionPaymentRailsRequest, bearer: string) {
    try {
      setFetching(true);
      const res = await api.fetchTransactionPaymentRails(params, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setPaymentRails(res.PaymentRails);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, paymentRails, fetchTransactionPaymentRails };
}
